import React from "react";
import styles from "../../assets/css/page.css";

export const CommitmentRules = () => {
  return (
    <div className="row">
      <div className="col-lg-6 col-sm-12 col-xs-12">
        <div className={`panel panel-default`}>
          <div className="panel-heading glnheading gln_lesspad">
            <p className="text-center glnh4">GREENLINK COMMITS TO...</p>
          </div>
          <div className={`panel-body gln_contactlesspad ${styles.rulePanel}`}>
            <ul>
              <li>Not compete with you by remaining a channel only company.</li>
              <li>
                Working with you one-on-one to set you up with training in our
                GreenLink University as well as during our “Game Plan” session.
              </li>
              <li>
                Provide you with a free NFR account for your entire business for
                as long as you remain in an active partner status.
              </li>
              <li>Hold your hand completely on the first two deals.</li>
              <li>Provide ongoing sales support from that point forward.</li>
              <li>
                Protecting the customer relationship by working together with
                you to resolve issues that might be related to the local network
                or ISP without any finger pointing.
              </li>
              <li>
                Providing you the support you need to market GreenLink services
                to customers.
              </li>
              <li>
                Help you achieve your goals by scheduling Executive Business
                Review meetings.
              </li>
              <li>
                Connecting you with the rest of the GreenLink Partner family – a
                high performance, highly supportive community of MSP Partners.
              </li>
              <li>
                Giving you access to our GreenLink Partner Portal with access to
                quoting, training, customer PBX management, marketing assets and
                more.
              </li>
              <li>
                Listening to you. We will be accessible and respond to your
                sales support requests in 24 hours or less.
              </li>
              <li>
                A personal and friendly partner relationship so that working
                with us feels like calling a good ‘old friend.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-lg-6 col-sm-12 col-xs-12">
        <div className={`panel panel-default`}>
          <div className="panel-heading glnheading gln_lesspad">
            <p className="text-center glnh4">PARTNER COMMITS TO...</p>
          </div>
          <div className={`panel-body gln_contactlesspad ${styles.rulePanel}`}>
            <ul>
              <li>
                Complete GreenLink training and be quick to ask for help when
                needed, and quick to share your wins and lessons.
              </li>
              <li>
                Work with our team by being an escalation point for customer
                network or ISP related troubleshooting.
              </li>
              <li>
                Share at least one success story with us so that we can help
                other prospects in understanding that working with an MSP when
                deploying VoIP is the best option.
              </li>
              <li>
                Referring at least one partner of your caliber, who you think
                will also take advantage of our partnership. This means we can
                spend less time looking for partners, and more time helping you.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Commitment/CommitmentRules.js